import { useEffect } from "react";
import { useIntl } from "react-intl";
import { Control } from "react-hook-form";

import type { TalentDetails } from "@aglocal/schema/Interview";

import { UseFormSetDefault } from "@/hooks/useSetDefault";

import { PostMeetingFormWithSummary } from "../form";
import { FIELD_LABELS } from "../messages";

import TextField from "./TextField";

export interface GoalsAndInterestsFieldProps {
  details: Readonly<TalentDetails> | undefined;
  control: Control<PostMeetingFormWithSummary>;
  setDefault: UseFormSetDefault<PostMeetingFormWithSummary>;
}

export default function GoalsAndInterestsField({
  details,
  control,
  setDefault,
}: GoalsAndInterestsFieldProps) {
  const { $t } = useIntl();
  const defaultValue = details?.goalsAndInterests ?? "";

  useEffect(() => {
    setDefault("goalsAndInterests", defaultValue);
  }, [defaultValue, setDefault]);

  return (
    <TextField
      name="goalsAndInterests"
      label={$t(FIELD_LABELS.goalsAndInterests)}
      control={control}
    />
  );
}
